module.exports = __webpack_public_path__ + "static/media/92-1-0.a398af2.aac";


//////////////////
// WEBPACK FOOTER
// ./static/music/92-1-0.aac
// module id = iVwr
// module chunks = 1